module.exports = __webpack_public_path__ + "static/media/jasmine.dce1e688.png";